import { render, staticRenderFns } from "./GetVsCode.vue?vue&type=template&id=6554cc2f&scoped=true&"
import script from "./GetVsCode.vue?vue&type=script&lang=js&"
export * from "./GetVsCode.vue?vue&type=script&lang=js&"
import style0 from "./GetVsCode.vue?vue&type=style&index=0&id=6554cc2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554cc2f",
  null
  
)

export default component.exports